export enum ListSelectTypes {
    MultiDropDown = "MultiDropDown",
    MultiCheckbox = "MultiCheckbox",
    SingleRadios = "SingleRadios",
    SingleDropDown = "SingleDropDown",
    JumboRadio = "JumboRadio"
}